import Box from 'components/shared/Box'
import Loader from 'components/shared/Loader'
import Text from 'components/shared/Text'
import { FormattedMessage } from 'react-intl'
import { useResolutions } from 'store/resolutions'

interface PaymentExpiryInfoProps {
    isCartFetching?: boolean
    isCouponApplied?: boolean
}

const PaymentExpiryInfo = ({
    isCartFetching,
    isCouponApplied,
}: PaymentExpiryInfoProps) => {
    const { isMobile } = useResolutions()

    return (
        <Box align="flex-end" mt={isCartFetching ? 8 : 16}>
            {isCartFetching ? (
                <Loader />
            ) : (
                <Text
                    variant="bodyExtraSmall"
                    color="grayscale_700"
                    align={isMobile ? 'left' : 'right'}
                >
                    {isCouponApplied ? (
                        <FormattedMessage
                            id="global.summary.payment_time_discount_info"
                            defaultMessage="Zapłać w ciągu 60 minut, inaczej zamówienie zostanie anulowane. <span>Nieopłacenie transakcji w wyznaczonym czasie zablokuje kod rabatowy do północy.</span>"
                            values={{
                                span: (chunks: string[]) => (
                                    <>
                                        {!isMobile && <br />}
                                        {chunks}
                                    </>
                                ),
                            }}
                        />
                    ) : (
                        <FormattedMessage
                            id="global.summary.payment_time_info"
                            defaultMessage="Zapłać w ciągu 60 minut, inaczej zamówienie zostanie anulowane."
                        />
                    )}
                </Text>
            )}
        </Box>
    )
}

export default PaymentExpiryInfo
